import { ReactNode } from 'react';
import { Stack } from '@mui/material';

export const BlockState = ({ children }: { children: ReactNode }) => (
  <Stack
    alignItems="center"
    justifyContent="center"
    gap={1}
    sx={{ flexGrow: 1, color: 'text.secondary', textAlign: 'center', py: 4 }}
  >
    {children}
  </Stack>
);
